import type React from "react";
import { Icon, tokens } from "@/design";

export interface DragHandleProps {
  onPointerDown: (e: React.PointerEvent) => void;
  onDoubleClick: () => void;
  minimized: boolean;
  onToggleMinimized: () => void;
  label: string;
  "data-testid"?: string;
}

export function DragHandle({
  onPointerDown,
  onDoubleClick,
  minimized,
  onToggleMinimized,
  label,
  "data-testid": testId,
}: DragHandleProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: 28,
        padding: `0 ${tokens.space[2]}px`,
        background: tokens.color.surface[2],
        borderBottom: tokens.border.thin,
        userSelect: "none",
        touchAction: "none",
        cursor: "grab",
      }}
      onPointerDown={onPointerDown}
      onDoubleClick={onDoubleClick}
      aria-label={`Drag handle for ${label}`}
      data-testid={testId}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "grab",
        }}
      >
        <Icon name="drag_indicator" size={16} decorative />
      </span>

      <span
        style={{
          flex: 1,
          textAlign: "center",
          fontSize: tokens.font.size.xs,
          color: tokens.color.ink.muted,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {label}
      </span>

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggleMinimized();
        }}
        onPointerDown={(e) => e.stopPropagation()}
        aria-label={minimized ? `Restore ${label}` : `Minimize ${label}`}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 20,
          height: 20,
          padding: 0,
          border: "none",
          background: "transparent",
          color: tokens.color.ink.secondary,
          cursor: "pointer",
          borderRadius: tokens.radius.sm,
        }}
      >
        <Icon
          name={minimized ? "keyboard_arrow_down" : "keyboard_arrow_up"}
          size={16}
          decorative
        />
      </button>
    </div>
  );
}
